import { IncidentDetail, IncidentDetailProps } from '../CardDetail'

interface AlertDeviceDetail {
  devices?: Record<string, string>[]
  [key: string]: any
}

interface ExtendedIncidentDetailProps extends IncidentDetailProps {
  fields: {
    alerts?: AlertDeviceDetail[]
    [key: string]: any
  }
}
const WindowDefenderDetail = ({ fields }: ExtendedIncidentDetailProps) => {
  const alertDetails = (fields as any)?.alerts
  const deviceDetails = (fields as any)?.alerts[0]?.devices

  return (
    <>
      <IncidentDetail title="Incident Details" fields={fields} />
      {Array.isArray(alertDetails) && alertDetails.map((alert: any, index: number) => <IncidentDetail key={index} title={`Alert ${index + 1}`} fields={alert} />)}
      {Array.isArray(deviceDetails) && deviceDetails.map((device: any, index: number) => <IncidentDetail key={index} title={`Device Details`} fields={device} />)}
    </>
  )
}

export default WindowDefenderDetail
